import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Wrench, XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F9F7F2] flex items-center justify-center">
      <div className="max-w-md w-full mx-4">
        <div className="bg-white rounded-xl shadow-lg p-8 text-center">
          <div className="flex items-center justify-center mb-6">
            <Wrench className="w-12 h-12 text-[#003B5C]" />
          </div>

          <XCircle className="w-16 h-16 text-[#FFB81C] mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-[#003B5C] mb-2">Payment Cancelled</h2>
          <p className="text-[#475569] mb-6">
            Your payment was cancelled. No charges have been made to your account.
          </p>
          
          <div className="space-y-3">
            <Button
              data-testid="try-again-btn"
              onClick={() => navigate(-1)}
              className="w-full bg-[#FFB81C] hover:bg-[#E5A000] text-[#003B5C] rounded-full py-3 font-bold"
            >
              Try Again
            </Button>
            <Button
              data-testid="back-home-cancel-btn"
              onClick={() => navigate('/')}
              variant="outline"
              className="w-full border-[#003B5C] text-[#003B5C] hover:bg-[#003B5C] hover:text-white rounded-full py-3 font-semibold"
            >
              Back to Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;